import { invokeApi } from "../utils";

export const getPermissionsApi = (page = 1) =>
  invokeApi({ path: "/permissions", method: "GET", queryParams: { page } });

export const createPermissionApi = (postData) =>
  invokeApi({ path: "/permissions", method: "POST", postData });

export const getPermissionByIdApi = (id) =>
  invokeApi({ path: `/permissions/${id}`, method: "GET" });

export const updatePermissionApi = (id, postData) =>
  invokeApi({ path: `/permissions/${id}`, method: "PUT", postData });

export const deletePermissionApi = (id) =>
  invokeApi({ path: `/permissions/${id}`, method: "DELETE" });
